
export default function(state = [], action) {
  switch (action.type) {
    case 'PAGINATE_INCIDENTS':
      return action.payload
    default:
      return state
  }
}
